/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authControllerCreateAccessTokenFromRefreshToken } from '../fn/authentication/auth-controller-create-access-token-from-refresh-token';
import { AuthControllerCreateAccessTokenFromRefreshToken$Params } from '../fn/authentication/auth-controller-create-access-token-from-refresh-token';
import { authControllerFindMyUser } from '../fn/authentication/auth-controller-find-my-user';
import { AuthControllerFindMyUser$Params } from '../fn/authentication/auth-controller-find-my-user';
import { authControllerLogin } from '../fn/authentication/auth-controller-login';
import { AuthControllerLogin$Params } from '../fn/authentication/auth-controller-login';
import { authControllerLoginAs } from '../fn/authentication/auth-controller-login-as';
import { AuthControllerLoginAs$Params } from '../fn/authentication/auth-controller-login-as';
import { authControllerLogout } from '../fn/authentication/auth-controller-logout';
import { AuthControllerLogout$Params } from '../fn/authentication/auth-controller-logout';
import { authControllerResetPassword } from '../fn/authentication/auth-controller-reset-password';
import { AuthControllerResetPassword$Params } from '../fn/authentication/auth-controller-reset-password';
import { authControllerSendForgotPasswordEmail } from '../fn/authentication/auth-controller-send-forgot-password-email';
import { AuthControllerSendForgotPasswordEmail$Params } from '../fn/authentication/auth-controller-send-forgot-password-email';
import { authControllerUpdateMyUser } from '../fn/authentication/auth-controller-update-my-user';
import { AuthControllerUpdateMyUser$Params } from '../fn/authentication/auth-controller-update-my-user';
import { LoginStatusDto } from '../models/login-status-dto';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authControllerLogin()` */
  static readonly AuthControllerLoginPath = '/api/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin$Response(params: AuthControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStatusDto>> {
    const obs = authControllerLogin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin(params: AuthControllerLogin$Params, context?: HttpContext): Observable<LoginStatusDto> {
    const resp = this.authControllerLogin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LoginStatusDto>): LoginStatusDto => r.body)
    );
  }

  /** Path part for operation `authControllerLoginAs()` */
  static readonly AuthControllerLoginAsPath = '/api/auth/login-as/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLoginAs()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerLoginAs$Response(params: AuthControllerLoginAs$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStatusDto>> {
    const obs = authControllerLoginAs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLoginAs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerLoginAs(params: AuthControllerLoginAs$Params, context?: HttpContext): Observable<LoginStatusDto> {
    const resp = this.authControllerLoginAs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LoginStatusDto>): LoginStatusDto => r.body)
    );
  }

  /** Path part for operation `authControllerSendForgotPasswordEmail()` */
  static readonly AuthControllerSendForgotPasswordEmailPath = '/api/auth/forgot-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerSendForgotPasswordEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerSendForgotPasswordEmail$Response(params: AuthControllerSendForgotPasswordEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authControllerSendForgotPasswordEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerSendForgotPasswordEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerSendForgotPasswordEmail(params: AuthControllerSendForgotPasswordEmail$Params, context?: HttpContext): Observable<void> {
    const resp = this.authControllerSendForgotPasswordEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authControllerResetPassword()` */
  static readonly AuthControllerResetPasswordPath = '/api/auth/reset-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerResetPassword$Response(params: AuthControllerResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authControllerResetPassword(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerResetPassword(params: AuthControllerResetPassword$Params, context?: HttpContext): Observable<void> {
    const resp = this.authControllerResetPassword$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authControllerFindMyUser()` */
  static readonly AuthControllerFindMyUserPath = '/api/auth/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerFindMyUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerFindMyUser$Response(params?: AuthControllerFindMyUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = authControllerFindMyUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerFindMyUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerFindMyUser(params?: AuthControllerFindMyUser$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.authControllerFindMyUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `authControllerUpdateMyUser()` */
  static readonly AuthControllerUpdateMyUserPath = '/api/auth/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerUpdateMyUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerUpdateMyUser$Response(params: AuthControllerUpdateMyUser$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStatusDto>> {
    const obs = authControllerUpdateMyUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerUpdateMyUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerUpdateMyUser(params: AuthControllerUpdateMyUser$Params, context?: HttpContext): Observable<LoginStatusDto> {
    const resp = this.authControllerUpdateMyUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LoginStatusDto>): LoginStatusDto => r.body)
    );
  }

  /** Path part for operation `authControllerCreateAccessTokenFromRefreshToken()` */
  static readonly AuthControllerCreateAccessTokenFromRefreshTokenPath = '/api/auth/refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerCreateAccessTokenFromRefreshToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerCreateAccessTokenFromRefreshToken$Response(params?: AuthControllerCreateAccessTokenFromRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStatusDto>> {
    const obs = authControllerCreateAccessTokenFromRefreshToken(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerCreateAccessTokenFromRefreshToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerCreateAccessTokenFromRefreshToken(params?: AuthControllerCreateAccessTokenFromRefreshToken$Params, context?: HttpContext): Observable<LoginStatusDto> {
    const resp = this.authControllerCreateAccessTokenFromRefreshToken$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LoginStatusDto>): LoginStatusDto => r.body)
    );
  }

  /** Path part for operation `authControllerLogout()` */
  static readonly AuthControllerLogoutPath = '/api/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerLogout$Response(params?: AuthControllerLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authControllerLogout(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerLogout(params?: AuthControllerLogout$Params, context?: HttpContext): Observable<void> {
    const resp = this.authControllerLogout$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
